<template>
    <MultiEmailList
        :saving="saving"
        group="maintenance_emails"
        headingText="§ui_button.show_maintenance_email"
        placeholder="§ui.placeholder_input_maintenance_email"
    />
</template>

<script>
import MultiEmailList from './MultiEmailList.vue'

export default {
    name: 'InputsMaintenanceEmails',

    components: {
        MultiEmailList,
    },

    props: {
        saving: {
            type: Boolean,
            required: true,
        },
    },
}
</script>
